import styled from 'styled-components';

export const AddressDataContainer = styled.div`
  display: flex;
  gap: 40px;
`;

export const AddressDataInputContainer = styled.div``;
